import { render } from "./CIS-Home-Cards.vue?vue&type=template&id=2043e8e2&scoped=true"
import script from "./CIS-Home-Cards.vue?vue&type=script&lang=js"
export * from "./CIS-Home-Cards.vue?vue&type=script&lang=js"

import "./CIS-Home-Cards.vue?vue&type=style&index=0&id=2043e8e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2043e8e2"]])

export default __exports__